export const TableUbaActionsOptions = {
  SELECT: "select",
  REMOVE: "remove",
  ALL: "all"
};
